import React from "react";
import "./OrientationPrompt.scss";

const OrientationPrompt = () => {
  return (
    <div className="orientation-prompt">
      <div className="turning-animation">
        <img
          src="/assets/imgs/landscapeSpinner.svg"
          alt="Icon"
          // className="icon"
        />
      </div>
      <img
        src="/assets/imgs/Alpaca-front-sunglasses-audio-side.svg"
        alt="Alpaca"
        className="alpaca-image"
      />
      <div className="speech-bubble-container">
        <img
          src="/assets/imgs/Speech-bubble-05.svg"
          alt="Speech Bubble"
          className="speech-bubble-image"
        />
        <p className="speech-bubble-text">
          Please rotate<br></br>your device to<br></br>landscape mode
        </p>
      </div>
    </div>
  );
};

export default OrientationPrompt;
